import { render, staticRenderFns } from "./atrbForm.vue?vue&type=template&id=0600f312&scoped=true"
import script from "./atrbForm.vue?vue&type=script&lang=js"
export * from "./atrbForm.vue?vue&type=script&lang=js"
import style0 from "./atrbForm.vue?vue&type=style&index=0&id=0600f312&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0600f312",
  null
  
)

export default component.exports